import * as React from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

interface IProps {
    onLogout: () => void;
    isLoggedIn: boolean;
}
export const Navigation = (props: IProps): JSX.Element => {
    const isLoggedIn = props.isLoggedIn;

    const onLogoutClick = () => {
        props.onLogout();
    };

    return (
        <Navbar variant="light" bg="light" expand="lg">
            <Link className="nav-link" role="button" to="/">
                <Navbar.Brand>NoteStore</Navbar.Brand>
            </Link>
            <Navbar.Toggle />
            <Navbar.Collapse id="basic-navbar-nav">
                {isLoggedIn ? (
                    <ul className="navbar-nav mr-auto">
                        <Link className="nav-link" role="button" to="/create">
                            <li className="nav-item">Create</li>
                        </Link>
                        <Link className="nav-link" role="button" to="/admin">
                            <li className="nav-item">Admin</li>
                        </Link>
                        <Link
                            className="nav-link"
                            role="button"
                            onClick={onLogoutClick}
                            to="/login"
                        >
                            <li className="nav-item">Logout</li>
                        </Link>
                    </ul>
                ) : (
                    <ul className="navbar-nav mr-auto">
                        <Link className="nav-link" role="button" to="/login">
                            <li className="nav-item">Login</li>
                        </Link>
                        <Link className="nav-link" role="button" to="/register">
                            <li className="nav-item">Register</li>
                        </Link>
                    </ul>
                )}
            </Navbar.Collapse>
        </Navbar>
    );
};
